import charteredBookingService from '@/api/charteredbooking'

export default {
  namespaced: true,
  actions: {
    async deleteCharteredBooking ({dispatch}, payload) {
      dispatch('Global/showLoading', null, {root: true})
      try {
        await charteredBookingService.deleteBooking(payload.charteredBus.id, payload.booking.id)
      }
      catch (error){
        return Promise.reject(error)
      }
      finally {
        dispatch('Global/hideLoading', null, {root: true})
      }
    }
  }
}
